var _path, _polygon, _polygon2, _line, _line2, _line3, _line4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnchor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "anchor",
    viewBox: "0 0 640 640",
    fill: "none",
    stroke: "#666",
    strokeWidth: 50,
    strokeLinecap: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M515,368.13c2.58,109.05-84.14,199.63-189.11,202.76c-109.22,3.26-203.46-89.2-200.89-202.76"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    strokeLinejoin: "round",
    points: "186.74,403.76 129.95,346.96 73.15,403.76 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    strokeLinejoin: "round",
    points: "566.85,404.13 510.06,347.33 453.26,404.13 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 431.67,
    y1: 113.11,
    x2: 208.33,
    y2: 113.11
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 431.67,
    y1: 196.44,
    x2: 208.33,
    y2: 196.44
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 283.67,
    y1: 66.22,
    x2: 315.56,
    y2: 610.67
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 351.44,
    y1: 64.17,
    x2: 320,
    y2: 610.89
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnchor);
export default __webpack_public_path__ + "static/media/anchor.6e67b259e87d69de4b51288449e327b1.svg";
export { ForwardRef as ReactComponent };